var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstallIcon = function SvgInstallIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Install Icon",
    transform: "translate(-4.726 -6)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(4.726 6)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-home",
    d: "m33.762 28.452-11.2 9.226v9.96a.972.972 0 0 0 .972.972l6.809-.018a.972.972 0 0 0 .967-.972v-5.816a.972.972 0 0 1 .972-.972h3.889a.972.972 0 0 1 .972.972v5.811a.972.972 0 0 0 .972.975l6.806.019a.972.972 0 0 0 .972-.972v-9.965l-11.2-9.22a.741.741 0 0 0-.931 0Zm17.695 6.271-5.08-4.185v-8.417a.729.729 0 0 0-.729-.729h-3.4a.729.729 0 0 0-.729.729v4.411l-5.442-4.475a2.916 2.916 0 0 0-3.706 0l-15.38 12.666a.729.729 0 0 0-.1 1.027l1.552 1.888a.729.729 0 0 0 1.027.1l14.292-11.777a.741.741 0 0 1 .93 0l14.292 11.772a.729.729 0 0 0 1.027-.1l1.549-1.884a.729.729 0 0 0-.1-1.029Z",
    fill: "#4e4e4e"
  }))));
};
export default SvgInstallIcon;